<div id="paginator" class="paginator-wrapper">
  <div class="row flex-item">
    <div class="col-sm-5 flex-item elements">

        <div *ngIf="!isTabletSizeScreen" class="visible-md visible-lg col-xs-3 col-sm-4 col-md-3">
          <span>Elementi per pagina</span>
        </div>
        <div [ngClass]="hasAutoRefresh ? 'col-xs-7' : 'col-xs-6'" class="col-sm-4 col-md-3">
          <div class="dropdown">
            <select autocomplete="off" id="row-qty" aria-label="Seleziona la quantità per riga" (change)="onSelectItemsQty($event.target.value)">
              <option value="10" [selected]="pagination.getItemsPerPage() === 10">10</option>
              <option value="20" [selected]="pagination.getItemsPerPage() === 20">20</option>
              <option value="30" [selected]="pagination.getItemsPerPage() === 30">30</option>
              <option value="40" [selected]="pagination.getItemsPerPage() === 40">40</option>
              <option value="50" [selected]="pagination.getItemsPerPage() === 50">50</option>
            </select>
          </div>
        </div>
        <div style="padding: 0;" class="col-xs-6 col-sm-4">
          <span>{{pagination.getCurrentPage() + 1}} - {{ pagination.getNPages() }} di {{pagination.getNItems()}}</span>
        </div>

    </div>
    <div *ngIf="hasAutoRefresh" class="col-xs-8 col-sm-5 paginator-actions flex-item-right">
      <ng-container>

          <div *ngIf="!isTabletSizeScreen" class="col-sm-6 visible-md visible-lg">
            <span>Aggiornamento automatico</span>
          </div>
          <div class="col-xs-12 col-sm-12">
            <div class="dropdown">
              <select (change)="setRefreshInterval(refreshSelect.value)" #refreshSelect>
                <option value="" [selected]="refreshIntervalDelay === ''">Disabilitato</option>
                <option value="5" [selected]="refreshIntervalDelay === '5'">ogni 5 min</option>
                <option value="15" [selected]="refreshIntervalDelay === '15'">ogni 15 min</option>
                <option value="30" [selected]="refreshIntervalDelay === '30'">ogni 30 min</option>
              </select>
            </div>
          </div>

      </ng-container>
      <!-- <div class="border-space"></div> -->
    </div>
    <div class="col-sm-2" style="display: flex; justify-content: end;">
      <div class="left" (click)="decrement()" [class.disabled]="pagination.getNItems() === 0 || pagination.getCurrentPage() <= 0"></div>
      <div class="right" (click)="increment()"
        [class.disabled]="pagination.getNItems() === 0 || ((pagination.getCurrentPage()+1) >= pagination.getNPages())" style="margin-top: 2px;">
      </div>
    </div>
  </div>
</div>
